export default __webpack_public_path__ + "44bd26f19999fa22dc29045c0eeea76b.png";